module.exports = __webpack_public_path__ + "fonts/iconfont.a6a0a40.ttf";